import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

import RichTextEditor from '../RichTextEditor';
import { questionEditorStyles } from './styles';

function EditorQuestionText(props: QuestionEditorProps) {
  const { className, question, onChange, viewMode } = props;
  const { t } = useTranslation();

  const onChangeText = useCallback(
    (questionText: string) => {
      onChange({ ...question, questionText });
    },
    [onChange, question],
  );

  return (
    <Stack className={className} direction="col">
      <RichTextEditor
        showRephraseOption
        className={questionEditorStyles}
        disabled={viewMode === 'view'}
        placeholder={t('QuizCreator:QuestionPlaceholder')}
        value={question.questionText}
        variant="heading-m"
        onChangeText={onChangeText}
      />
    </Stack>
  );
}

export default EditorQuestionText;
